import { FormValues } from './FormValues';
export default function validateFormData(formData: FormValues) {
  if (formData.recurrences.length === 0) {
    return 'Please add at least one day of the week.';
  }

  return null;
}
